import { useState, useEffect } from 'react'

const usePortal = (portalName = 'body') => {
    const [portal, setPortal] = useState<Element | null>(null)

    useEffect(() => {
        setPortal(document.querySelector(`.portal-${portalName}`))
    }, [portalName])

    return portal
}

export default usePortal
